package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class AttendanceRepository(private val httpClient: HttpClient) {
    suspend fun checkIn(req: CheckInRequest): Result<AttendanceDto> = runCatching {
        httpClient.post("attendance/check-in") { setBody(req) }.body()
    }

    suspend fun checkOut(req: CheckOutRequest): Result<Unit> = runCatching {
        httpClient.post("attendance/check-out") { setBody(req) }
    }

    suspend fun getAttendance(workplaceId: Long, date: String): Result<List<AttendanceDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/attendance") { parameter("date", date) }.body()
    }

    suspend fun getAttendanceRange(workplaceId: Long, from: String, to: String): Result<List<AttendanceDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/attendance/range") {
            parameter("from", from); parameter("to", to)
        }.body()
    }

    suspend fun getSnapshot(workplaceId: Long): Result<List<SnapshotEntryDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/snapshot").body()
    }

    suspend fun updateAttendance(attendanceId: Long, req: UpdateAttendanceRequest): Result<Unit> = runCatching {
        httpClient.put("attendance/$attendanceId") { setBody(req) }
    }

    suspend fun getAuditLog(attendanceId: Long): Result<List<AuditLogEntryDto>> = runCatching {
        httpClient.get("attendance/$attendanceId/audit-log").body()
    }

    suspend fun getMyActiveAttendance(workplaceId: Long): Result<AttendanceDto?> = runCatching {
        httpClient.get("workplaces/$workplaceId/my-attendance").body()
    }

    suspend fun exportCsv(workplaceId: Long, from: String, to: String): Result<String> {
        return try {
            val response = httpClient.get("workplaces/$workplaceId/attendance/export") {
                parameter("from", from); parameter("to", to)
            }
            if (response.status == HttpStatusCode.UnprocessableEntity) {
                Result.failure(Exception(response.bodyAsText()))
            } else {
                Result.success(response.body())
            }
        } catch (e: ResponseException) {
            Result.failure(Exception(e.response.bodyAsText().ifBlank { e.message ?: "Export misslyckades" }))
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
